import React from 'react';
import Images from '../assets/AllImages';

const trainingCard1 = [
    { image: Images.trainner1, title: "Artiol Shala", },
    { image: Images.trainner2, title: "Granit Imeri", },
    { image: Images.trainner3, title: "Gent Bislimi", }
]

const trainingCard2 = [
    { image: Images.trainner4, title: "Besart Shala", },
    { image: Images.trainner5, title: "Mergim Maloku ", },
    { image: Images.trainner6, title: "Vesa Klaiqi", }
];



const ABOUTUS = () => {
    return (

        <>

            <div className="container-fluid bg-primary px-0 py-5 mb-5">
                <div className="row text-center d-flex justify-content-center m-auto">
                    <div className="col-12 col-md-6 text-white px-4 px-sm-0">
                        <img src={Images.Vactor} alt="" className='mb-5' style={{ width: "40%" }} />
                        <h4 className='fw-bold'>WHO WE ARE</h4>
                        <p className='pb-3'>Step Arena is the largest and most advanced sports and wellness complex in the Balkans — a place where performance meets purpose. Located on a tranquil hillside near Prishtina, our facility is built to inspire athletes, families, and wellness-minded individuals. Surrounded by clean air and nature, Step Arena offers an escape from the noise of daily life, while delivering an environment of excellence, care, and progress.</p>
                        <h4 className='fw-bold'>WHO WE DO</h4>
                        <p>We provide a full spectrum of professional and recreational services centered on health, movement, and well-being. Our infrastructure includes Olympic-standard indoor and outdoor swimming pools, a dedicated Spa and Fitness center, a modern hotel for teams and guests, and a restaurant focused on nutrition and balance. Whether it’s competitive training, family recreation, rehabilitation, or seasonal programs like camps and aquafitness — Step Arena is a hub where physical, mental, and social health come together.</p>
                    </div>
                </div>
            </div>

            {/* Create A Experience Section */}

            <section className="container">
                <div className="row">
                    <div className="col-12 col-md-6 px-0 mb-5 mb-sm-0 experience-images">
                        <div className='exp-img-container'>
                            <img src={Images.SwimingSupportMan1} alt="" />
                            <img src={Images.SwimingSupportMan2} alt="" />
                        </div>
                        <div className='bg-primary experience-number'>
                            <span>10+ <br />Experience</span>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 d-flex justify-content-center flex-column ps-5">
                        <h4 className='text-primary fw-bold'>WHO WE ARE</h4>
                        <p>What sets Step Arena apart is not just its scale, location, or uniqueness but the spirit with which it was built. It is a visionary and passionate project created to fill a long-missing gap for the people of Prishtina a place where youth, athletes, and families can spend time in a healthy, inspiring, and purpose-driven environment.</p>
                        <h5 className='text-primary fw-bold'>Step Arena Features:</h5>
                        <ul>
                            <li>Two Olympic-sized swimming pools (indoor and outdoor)</li>
                            <li>Dedicated zones for training and recovery – Spa & Fitness</li>
                            <li>Modern changing rooms and athlete facilities</li>
                            <li>Spectator stands and family-friendly spaces</li>
                            <li>A contemporary hotel and a restaurant with advanced cuisine</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* Create a Trainning Section */}

            <section className="container mt-5 text-center">
                <p>OUR STAFF</p>
                <h5 className='text-primary fw-bold pb-4'>Get the training under best trainers</h5>
                <div className="row mb-3 gap-3 flex-nowrap">

                    {trainingCard1.map((trainer, index) => (
                        <div key={index} className="col-12 col-md-4 col-sm-6 border rounded">
                            <img src={ trainer.image } alt={trainer.title} className='w-100 pb-4' />
                            <h5>{ trainer.title }</h5>
                            <span className='text-primary'>Trainer</span>
                        </div>
                    ))}

                </div>

                <div className="row mb-3 text-center gap-3 flex-nowrap">
                    
                    {trainingCard2.map((trainer, index) => (
                        <div key={index} className="col-12 col-md-4 col-sm-6 border rounded">
                            <img src={ trainer.image } alt={trainer.title} className='w-100 pb-4' />
                            <h5>{ trainer.title }</h5>
                            <span className='text-primary'>Trainer</span>
                        </div>
                    ))}

                </div>
            </section>

        </>
    )
}

export default ABOUTUS;
